import React from "react";

const FinishedIcon =({className}:{className?: string})=> (
<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<mask id="mask0_941_683" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="35" height="35">
<rect width="35" height="35" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_941_683)">
<path d="M13.9297 26.2503L5.61719 17.9378L7.69531 15.8597L13.9297 22.0941L27.3099 8.71387L29.388 10.792L13.9297 26.2503Z" fill="white"/>
</g>
</svg>

);

export default FinishedIcon;